import { useContext } from "react";
import { useSelector } from "react-redux";
import { Tag, TagsScope, Id } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  tags: Tag[];
  retrieveProjectsElementsTags(
    request: Boundaries["retrieveProjectsElementsTags"]["request"],
  ): void;
}

function useRetrieveProjectsElementsTags(
  scope?: TagsScope,
  scopeId?: Id,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveProjectsElementsTagsRequestPending(scope, scopeId),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveProjectsElementsTagsRequestSuccess(scope, scopeId),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveProjectsElementsTagsRequestFailure(scope, scopeId),
    ),
    tags: useSelector(() => selector.getProjectsElementsTags(scope, scopeId)),
    retrieveProjectsElementsTags: core.retrieveProjectsElementsTags,
  };
}

export { useRetrieveProjectsElementsTags };
